import appConfigs from "@configs/app";
import { mapGetters } from "vuex";
import { NAMESPACE } from "@modules/attempt/service/attempt.constant";
import { isEmpty } from "@utils/var.check.ts";
const s3GameAvatarURL = "https://static.dev.sls.ufinity.com/images/AchievementAvatar.svg";

export default {
  methods: {
    getUserAvatarUrlFromFilenameAndVersion(fileName, fileVersion) {
      //fileName here does not contain extension
      //when user's avatar is default one, its url will be located under this path of resource bucket:
      // /avatar/user/default_student.svg
      //when user's avatar is not default one,
      // /avatar/user/avatar_uuid/avatar_file_version/avatar_uuid.svg
      if (fileName.startsWith("default")) {
        return `${appConfigs.s3ResourceDomain}/avatar/user/${fileName}.svg`;
      } else {
        return `${appConfigs.s3ResourceDomain}/avatar/user/${fileName}/${fileVersion}/${fileName}.svg`;
      }
    },
    getUserAvatarUrl(user) {
      if (user.gameAvatarFilename) {
        if (user.gameAvatarFilename.startsWith("default")) {
          return s3GameAvatarURL;
        }
        return `${appConfigs.s3ResourceDomain}/gamification/${this.getGameBook.uuid}/game_avatars/${user.gameAvatarFilename}`;
      }
      return this.getUserAvatarUrlFromFilenameAndVersion(
        user.avatarFilename,
        user.avatarFileVersion,
      );
    },
    isGameAvatar(user) {
      return !isEmpty(user.gameAvatarFilename);
    },
  },
  computed: {
    ...mapGetters(NAMESPACE.RESOURCE, ["getGameBook"]),
  },
};
